import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import IntegrationsSegmentOutController from 'cio/pods/integrations/segment_out/controller';
import SegmentAuthService from 'cio/services/segment-auth';

export default class SegmentOutRoute extends Route {
  @service segmentAuth!: SegmentAuthService;

  crumb() {
    return {
      name: 'Segment',
      path: 'integrations.segment_out',
    };
  }

  setupController(controller: IntegrationsSegmentOutController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.fetchIntegrationTask.perform();
  }

  resetController(controller: IntegrationsSegmentOutController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.integration = undefined;
      controller.key = null;
      controller.events = {};
      controller.original = { key: null, events: {} };
    }
  }
}
